'use client';

import { FunctionComponent } from 'react';

import { WiredPageCannotLoad } from 'src/experiences/Error/PageCannotLoad/PageCannotLoad.wired';
import { useOAuthErrorState } from './useOAuthErrorState';

export const WiredOAuthError: FunctionComponent = () => {
    useOAuthErrorState();
    return <WiredPageCannotLoad />;
};
